import Page from '../components/client/Page'
const config = require('../config/index')

var routerMap = {
  mode: 'history',
  base: '/' + config.VIEW_NAME,
  routes: [
    {
      path: '/:pageKey',
      component: Page
    },
    {
      path: '*',
      component: Page
    }
  ]
}

export default routerMap
